import { Link } from "react-router-dom";
import { FaLink } from "react-icons/fa6";
import { useTheme, THEMES } from "../ThemeContext";

const LABELS = {
  atelier: "Atelier",
  grid: "Grid",
  noir: "Noir",
  indigo: "Indigo",
};

function Footer() {
  const { theme, setTheme } = useTheme();
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="wrap">
        <div className="footer-themes">
          <span className="ft-intro">Choose a visual direction</span>
          <div className="theme-switch" role="group" aria-label="Choose a visual direction">
            <span className="ts-label">Theme</span>
            {THEMES.map((t) => (
              <button
                key={t}
                type="button"
                className={theme === t ? "active" : undefined}
                aria-pressed={theme === t}
                onClick={() => setTheme(t)}
              >
                {LABELS[t]}
              </button>
            ))}
          </div>
        </div>
        <div className="foot">
          <span>© {year} Abdul Basit Iqbal</span>
          <span>Designed &amp; built with care</span>
          <Link to="/linktree" className="top-link">
            <FaLink aria-hidden="true" />
            Linktree
          </Link>
          <a href="#home" className="top-link">
            Back to top
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 19V5M5 12l7-7 7 7" />
            </svg>
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
